'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Root container directive, who will drive the autosizing process of it's autosizable container.
 */
ngModule.directive("autosizingContainer", function ($debounce) {
  return {
    restrict: "A",
    priority: 10,
    require: ["autosizingContainer", "sizableContainer", "?^hideableContainer"],
    link: function link($scope, $el, $attrs, controllers) {
      var autosizingCtrl = controllers[0],
        autosizableCtrl = controllers[1],
        hideableCtrl = controllers[2];
      autosizingCtrl.initialize(autosizableCtrl, hideableCtrl);
    },
    controller: function controller($scope, $element) {
      var ctrl = this,
        disabled = false,
        autosizableCtrl = null,
        hideableCtrl = null,
        needResize = false;
      ctrl.initialize = function (_autosizableCtrl, _hideableCtrl) {
        autosizableCtrl = _autosizableCtrl;
        hideableCtrl = _hideableCtrl;
        if (hideableCtrl) {
          needResize = isVisible();
          hideableCtrl.on("visibility:change", function (visible) {
            if (isVisible() && needResize) {
              resizeHandler();
            }
          });
        }
        $scope.$on("$resize", resizeHandler);
        $scope.$on("$autosize", resizeHandler);
        resizeHandler();
      };
      ctrl.enableAutosizing = function () {
        if (!disabled) {
          return;
        }
        disabled = false;
        resizeHandler();
      };
      ctrl.disableAutosizing = function () {
        if (disabled) {
          return;
        }
        disabled = true;
        // TODO : this will not be enought if components are already resized.
        // Need to propagate the information
        // but this work for now...
      };
      ctrl.getContainerHeight = function () {
        var reference = $element.closest(".autosize-reference"); // TODO : improve
        if (!reference.length) {
          reference = $element;
        }
        return reference.height();
      };
      ctrl.applyHeight = function () {
        var height = ctrl.getContainerHeight();
        // console.log("autosizing : applyHeight ->", height);
        autosizableCtrl.setHeight(height);
      };
      var isVisible = function isVisible() {
        return hideableCtrl ? hideableCtrl.isVisible() : true;
      };
      var resizeHandler = $debounce(function () {
        if (disabled) {
          // this is only to allow non-fixed height reports to resize when panel opens.
          // see Layout.js
          // TODO : should be handled in the layout controller.
          $scope.$broadcast("$redraw");
          return;
        }
        if (isVisible()) {
          ctrl.applyHeight();
          needResize = false;
        } else {
          needResize = true;
        }
      }, 100, false);
    }
  };
});

/**
 * Use on a sizableContainer to set requested height of the container, either in % or px.
 *
 * Examples
 * - <div sizable-container as-fixed-height="50%">...</div>
 * - <div sizable-container as-fixed-height="200px">...</div>
 */
ngModule.directive("asFixedHeight", function () {
  return {
    restrict: "A",
    require: "sizableContainer",
    priority: 5,
    link: {
      pre: function pre($scope, $el, $attrs, containerCtrl) {
        containerCtrl.setRequestedHeightHandler(function () {
          return $attrs.asFixedHeight;
        });
      }
    }
  };
});

/**
 * Container able to resize it's content when asked.
 */
ngModule.directive("sizableContainer", function ($debounce, autosizingService, directiveUtils) {
  return {
    restrict: "A",
    priority: 1,
    link: function link($scope, $el, $attrs, ctrl) {
      var parentContainer = directiveUtils.getParentController($el, "sizableContainer");
      if (parentContainer) {
        parentContainer.addComponent(ctrl);
        $scope.$on("$destroy", function () {
          parentContainer.removeComponent(ctrl);
        });
      }
      ctrl.initialize();
    },
    controller: function controller($scope, $element, $attrs) {
      var ctrl = this,
        requiredHeightHandler = null,
        strategy = null,
        allocatedHeight = null,
        components = [];
      ctrl.initialize = function () {
        strategy = autosizingService.getContainerStrategy(ctrl, $element, $attrs);
      };
      ctrl.getComponents = function () {
        return components;
      };
      ctrl.addComponent = function (componentCtrl) {
        components.push(componentCtrl);
        debouncedApplyHeight();
      };
      ctrl.removeComponent = function (componentCtrl) {
        var componentIdx = _.indexOf(components, componentCtrl);
        if (componentIdx > -1) {
          components.splice(componentIdx, 1);
          debouncedApplyHeight();
        }
      };
      ctrl.setRequestedHeightHandler = function (handler) {
        requiredHeightHandler = handler;
      };
      ctrl.getRequestedHeight = function () {
        if (requiredHeightHandler) {
          return requiredHeightHandler();
        } else {
          return null;
        }
      };
      ctrl.setHeight = function (_allocatedHeight) {
        allocatedHeight = _allocatedHeight;
        applyHeight();
      };
      ctrl.refreshWidth = function () {
        _.each(components, function (component) {
          return component.refreshWidth();
        });
      };
      var applyHeight = function applyHeight() {
        if (!allocatedHeight) {
          return;
        }
        var offset = $element.outerHeight(true) - $element.innerHeight();
        var usableHeight = allocatedHeight - offset;
        strategy.setHeight(usableHeight);
      };
      var debouncedApplyHeight = $debounce(applyHeight, 100);
    }
  };
});
ngModule.directive("sizeableComponent", function (autosizingService) {
  return {
    restrict: "A",
    priority: -1,
    require: ["sizeableComponent", "^sizableContainer"],
    link: function link($scope, $el, $attrs, controllers) {
      var ctrl = controllers[0],
        containerController = controllers[1];
      ctrl.initialize();
      containerController.addComponent(ctrl);
      $scope.$on("$destroy", function () {
        containerController.removeComponent(ctrl);
      });
    },
    controller: function controller($scope, $element) {
      var ctrl = this,
        delegate = null;
      ctrl.initialize = function () {
        delegate = autosizingService.getDelegate($element);
        if (delegate == null) {
          console.error('Pas de delegate trouvé pour gérer le resizing de ', $element);
        }
        $scope.$on("$resize-x", function () {
          // PGA : dirty approach, event triggered from Layout region only...
          delegate.refreshWidth();
        });
      };
      ctrl.refreshWidth = function () {
        return delegate.refreshWidth();
      };
      ctrl.setHeight = function (height) {
        if (delegate == null) {
          console.error('no delegate for ' + $element);
        }
        delegate.setHeight(height);
      };
      ctrl.getRequestedHeight = function () {
        return null;
      };
    }
  };
});
ngModule.directive("fixedComponent", function () {
  return {
    restrict: "A",
    require: ["fixedComponent", "^sizableContainer"],
    link: function link($scope, $el, $attrs, controllers) {
      var ctrl = controllers[0],
        containerController = controllers[1];
      containerController.addComponent(ctrl);
      $scope.$on("$destroy", function () {
        containerController.removeComponent(ctrl);
      });
    },
    controller: function controller($scope, $element) {
      var ctrl = this;
      ctrl.refreshWidth = angular.noop;
      ctrl.getRequestedHeight = function () {
        return $element.outerHeight(true) + "px";
      };
    }
  };
});
ngModule.directive("tlSizeableBlock", function () {
  return {
    restrict: "A",
    controller: function controller() {
      // required to be declared as a component type.
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/autosizing/autosizing.js
// module id = 2916
// module chunks = 13